import { FormLabel as ChakraFormLabel } from '@chakra-ui/react';

export const FormLabel = ChakraFormLabel;
